import { useEffect, useRef } from 'react'

import { disableDarkMode, enableDarkMode } from '@interco/inter-ui'
import { interWbSession } from '@interco/inter-webview-bridge'

const DarkModeLoader = () => {
  const isMounted = useRef(false)

  const handleDarkMode = async () => {
    try {
      const appInfo = await interWbSession.getAppInfo()
      if (appInfo.isDarkMode) {
        document.body.style.backgroundColor = '#161616'
        enableDarkMode()
        localStorage.setItem('isDarkMode', 'true')
      } else {
        document.body.style.backgroundColor = '#fff'
        disableDarkMode()
        localStorage.setItem('isDarkMode', 'false')
      }
    } catch (e) {
      console.log('error', e)
    }
  }

  if (!isMounted.current) {
    handleDarkMode()
  }

  useEffect(() => {
    isMounted.current = true
  }, [])

  return null
}

export default DarkModeLoader
